/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 5/10/2022
 */


import {Type} from "class-transformer";
import WheelSegmentItem from "@shared/WheelModel/WheelSegmentItem";
import MultipleTakesData from "@shared/WheelModel/MultipleTakesData";
import TagItem from "@shared/Tags/TagItem";
import AutoTagsData from "@shared/WheelModel/AutoTagsData";
import AdditionalInfoItem from "@shared/Profile/AdditionalInfoItem";
import dayjs from "dayjs";
import FilterableItem from "@shared/Filterable/FilterableItem";
import RedirectData from "@shared/WheelModel/RedirectData";


let defaultWelcomeText =
	"This wheel is a tool to help you reflect on your satisfaction across all areas of your life and identify where coaching could create the most value for you." +
	"<br/><br/>" +
	"•Rate your current level of satisfaction<br/>" +
	"•Rate where you would like to be in the future<br/>" +
	"<br/><br/>" +
	"1 = completely unsatisfied, and 10 = completely satisfied."


let defaultThankYouText = "<h1>Thank you for completing this assessment.<br/>I'll get in touch with you shortly.</h1>"

export default class WheelItem extends FilterableItem{

	title: string = null
	needsSetup: boolean = false

	@Type(() => WheelSegmentItem)
	segmentArray: WheelSegmentItem[] = []

	@Type(() => MultipleTakesData)
	multipleTakesData: MultipleTakesData = new MultipleTakesData()

	@Type(() => AutoTagsData)
	autoTagsData: AutoTagsData = new AutoTagsData([new TagItem("wheel of life")])

	@Type(() => AdditionalInfoItem)
	additionalInfo: AdditionalInfoItem = new AdditionalInfoItem()

	welcomeMessage: string = defaultWelcomeText
	thankYouMessage: string = defaultThankYouText
	isCustomWelcomeMessageEnabled: string = null
	isCustomThankYouMessageEnabled: string = null

	@Type(() => RedirectData)
	redirectData: RedirectData = new RedirectData()

	redirectUrl: string = null

	embeddedUrl: string = null

	isNowVsFutureEnabled: boolean = true


	constructor(title: string = "", segmentArray: WheelSegmentItem[] = []) {
		super();
		this.title = title;
		this.segmentArray = segmentArray;
	}

	addSegment(segment){
		this.segmentArray.push(segment)
	}
	updateSegment(segment, index){
		this.segmentArray.splice(index, 1, segment)
	}
	deleteSegment(index){
		this.segmentArray.splice(index, 1)
	}


	resetAnswers(){
		this.segmentArray.forEach(segment => segment.reset())
	}

	getAnswers(){
		return this.segmentArray
	}

	getCurrentAnswers(){
		return this.segmentArray
	}

	getWelcomeMessage(){
		return this.isCustomWelcomeMessageEnabled && this.welcomeMessage ? this.welcomeMessage : defaultWelcomeText
	}
	getThankYouMessage(){
		return this.isCustomThankYouMessageEnabled && this.thankYouMessage ? this.thankYouMessage : defaultThankYouText
	}

	isAllAreasAssessed(){
		let segmentArray = this.getCurrentAnswers()
		console.log("WheelItem.isAllAreasAssessed: segmentArray = ", segmentArray)
		return this.isAllResponsesSet(segmentArray)
	}
	isAllFutureAreasAssessed(){
		let segmentArray = this.getCurrentAnswers()
		console.log("WheelItem.isAllFutureAreasAssessed: segmentArray = ", segmentArray)
		return this.isAllFutureResponsesSet(segmentArray)
	}
	fillMissedFutureFromCurrent(){
		let segmentArray = this.getCurrentAnswers()
		for(let segment of segmentArray){
			if(!segment.valueFuture){
				segment.valueFuture = segment.value
			}
		}
	}

	isAllResponsesSet(segmentArray){
		for(let segment of segmentArray){
			if(!segment.value){
				return false
			}
		}
		return true
	}
	isAllFutureResponsesSet(segmentArray){
		for(let segment of segmentArray){
			if(!segment.valueFuture){
				return false
			}
		}
		return true
	}

	segmentsFormatted(maxNumberOfSegments){
		let dif = this.segmentArray.length - maxNumberOfSegments
		let postfix = dif > 0 ? `... (+${dif} more)` : ""
		return this.segmentArray
			.filter(item => !!item.label)
			.slice(0, maxNumberOfSegments)
			.map(item => item.label)
			.join(", ") + postfix
	}

	prepareForCopy(){
		super.prepareForCopy()
		this.embeddedUrl = null
	}

	completedOnFormatted(){
		return dayjs(this.createdAt).format("MMM DD, YYYY")
	}

}

